export default __webpack_public_path__ + "static/media/16_ECSI.49c6001f.png";